// @flow
import React from 'react';
import { Trans } from 'react-i18next';


import get from 'app/common/lib/get';
import { Link } from 'react-router';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import nope from 'app/common/lib/nope';
import { TARIFF_DAILY } from 'app/common/constants/tariffs';

import styles from './NotEnoughLink.scss';


const cx = classNames.bind(styles);
const enhance = connect(
  (state, props) => ({
    isNotEnoughWhilePay: get(state, ['apps', 'subs', props.subId, 'tariff', 'kind'], '') === TARIFF_DAILY
      || state.apps.opts.isNotEnoughWhilePay,
  })
);

type Props = {
  subId?: number | string,
  handlePay: (e: SyntheticEvent<HTMLElement>) => void,
  isNotEnoughWhilePay: boolean,
  disabled: boolean,
  name: string,
};

const NotEnoughLink = ({ handlePay, isNotEnoughWhilePay, disabled, name }: Props) => (isNotEnoughWhilePay
  ? <Trans i18nKey="tariff:not_enough_link1">
    {'Не достаточно средств. '}
    <Link to="/finances/refill/replenish">Пополнить</Link>
  </Trans>
  : <Trans i18nKey="tariff:not_enough_link2">
    {'Не оплачено. '}
    <a
      href="pay"
      onClick={disabled ? nope : handlePay}
      name={name}
      className={cx({ disabled })}
    >
      {'Оплатить'}
    </a>
  </Trans>
);

export default enhance(NotEnoughLink);
